import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles.css';
import './GlobalFonts.css';
import './styles/responsive-production.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);


